import BaseFormController from "../../../../validation/BaseFormController";
import {FormField, OptionalFormField, RequiredFormField} from "../../../../validation/FormField";
import {none, Option, option} from "ts-option";
import FormValidation from "../../../../validation/FormValidation";
import {ValidationResult} from "../../../../validation/ValidationResult";
import SerialNumbersData from "../../../../model/job/SerialNumbersData";
import FormValidators from "../../../../validation/FormValidators";
import WarrantyInfoData from "../WarrantyInfoData";

const uuidv4 = require("uuid/v4");

export default class WarrantyInfoFrom extends BaseFormController<WarrantyInfoFrom> {
	constructor(formId: string,
		public readonly merchantId: RequiredFormField<string>,
		public readonly title: RequiredFormField<string>,
		public readonly boiler: RequiredFormField<string>,
		public readonly cylinder: OptionalFormField<string>,
		public readonly filter: OptionalFormField<string>,
		public readonly control: OptionalFormField<string>) {
		super(merchantId, formId);
	}

	static createWarrantyInfoFrom({
		merchantId = none,
		title = none,
		boiler = none,
		cylinder = none,
		filter = none,
		control = none
	}) {
		return new WarrantyInfoFrom(
			uuidv4(),
			RequiredFormField.create<string>(merchantId, 'Merchant  is required'),
			RequiredFormField.create<string>(title, 'Title is required'),
			RequiredFormField.create<string>(boiler, 'Boiler serial # is required', [
				FormValidators.nonEmptyString("Boiler serial # is required")
			]),
			OptionalFormField.create<string>(cylinder),
			OptionalFormField.create<string>(filter),
			OptionalFormField.create<string>(control)
		);
	}

	static createFormWarrantyInfo(serialNumbers: Option<SerialNumbersData>, title: Option<string>, merchantId: Option<string>) {
		return WarrantyInfoFrom.createWarrantyInfoFrom({
			merchantId: merchantId,
			title: title,
			boiler: serialNumbers.flatMap(sn => sn.boiler),
			cylinder: serialNumbers.flatMap(sn => sn.cylinder),
			filter: serialNumbers.flatMap(sn => sn.filter),
			control: serialNumbers.flatMap(sn => sn.control)
		});
	}

	validate(): WarrantyInfoFrom {
		return FormValidation.validateForm<WarrantyInfoFrom>(this, (form, config) => form.copy(config));
	}

	onValid(onValid: (data: WarrantyInfoData) => void,
		onInvalid: () => void): ValidationResult<WarrantyInfoData> {
		return FormValidation.validateFields(
			[this.merchantId, this.title, this.boiler, this.cylinder, this.filter, this.control],
			() => {
				return new WarrantyInfoData(
					this.merchantId.getOptionalValue(),
					this.title.getOptionalValue(),
					this.boiler.getOptionalValue(),
					this.cylinder.getOptionalValue(),
					this.filter.getOptionalValue(),
					this.control.getOptionalValue()
				);
			}).onSuccess(data => onValid(data)).onFailure(onInvalid);
	}

	copy({
		merchantId = this.merchantId,
		title = this.title,
		boiler = this.boiler,
		cylinder = this.cylinder,
		filter = this.filter,
		control = this.control
	}): WarrantyInfoFrom {
		return new WarrantyInfoFrom(this.formId, merchantId, title, boiler, cylinder, filter, control);
	}

	fields(): Array<FormField<any>> {
		return [];
	}
}